import { render, staticRenderFns } from "./CornerAlert.vue?vue&type=template&id=a9bcd6c0&scoped=true&"
import script from "./CornerAlert.vue?vue&type=script&lang=js&"
export * from "./CornerAlert.vue?vue&type=script&lang=js&"
import style0 from "./CornerAlert.vue?vue&type=style&index=0&id=a9bcd6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bcd6c0",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow})
    

export default component.exports